var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsXfi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#DD60FC",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9132 16.5168C14.9372 16.7829 14.2719 17.1221 14.0627 16.956C12.2605 15.5258 9.74107 15.5254 7.93851 16.9548C7.72914 17.1209 7.06315 16.7811 7.08706 16.515C7.197 15.2913 6.70865 14.803 5.48501 14.9129C5.21886 14.9369 4.8791 14.2708 5.04514 14.0615C6.47457 12.259 6.47417 9.73987 5.04397 7.93785C4.87786 7.72855 5.21708 7.06327 5.4832 7.08723C6.70817 7.19754 7.19706 6.70925 7.08706 5.48501C7.06314 5.21886 7.72914 4.8791 7.93851 5.04514C9.74107 6.47459 12.2605 6.4742 14.0627 5.04397C14.2719 4.87787 14.9372 5.21708 14.9132 5.4832C14.8028 6.70873 15.2915 7.19757 16.5168 7.08724C16.7829 7.06327 17.1221 7.72851 16.956 7.93781C15.5262 9.73985 15.5258 12.2591 16.9549 14.0615C17.1209 14.2709 16.7811 14.9369 16.515 14.9129C15.291 14.803 14.8028 15.2919 14.9132 16.5168Z",
    fill: "#DD60FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsXfi);
export default __webpack_public_path__ + "static/media/esXfi.41ba8beb24febd397c3dad6cdc531930.svg";
export { ForwardRef as ReactComponent };